import React, { Component, ChangeEvent, MouseEvent } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import FilterItem from "../FindAnArtist/filterItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import FindAnArtistService, { artistCardUIType } from "../../services/FindAnArtistService";
import { AxiosResponse } from "axios";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import ArtistUtilities, { filterObject } from "../FindAnArtist/FindAnArtistUtils";
import { ServiceSubTypeId } from "../../services/ArtistService";
import GlobalService from "../../services/GlobalService";
import { Slider, CheckBox, Button, Popup, ScrollView, SelectBox } from "devextreme-react";
import {
    SliderOnChangedEvent,
    CheckBoxOnValueChanged,
    SelectBoxOnValueChangedEvent,
} from "../../types/DevExtremeTypes";
import ArtistGrid from "./ArtistGrid";
import ArtistProfileComponent from "../Artist-Profile/ArtistProfileComponent";
import GeographyPanel from "../side-bar/GeographyPanel";
import LookupService, { LookupTypeItem } from "../../services/LookupService";
import { ServiceType } from "../../common/ServiceUtilities";


interface ArtistGridPageProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
    history: any;
}

interface ArtistGridPageState {
    cardUIType: string; //This would communicate to the Card List rendering panel of which type of cards to display.
    showProgressIndicator: boolean;
    formView: boolean;
    isPending: boolean;
    requestStatus: string;
    typeListObject: filterObject;
    typeData: any;
    countOftypes: number;
    artistSearchField: string;
    subTypesList: string;
    requestButtonClickCount: number;
    firstTimeRequest: boolean;
    isPopUpToShow: boolean;
    artistSearchVal: string;
    isClickArtistSearch: boolean;
    isClickSearchButton: boolean;
    postCode: string;
    distance: string;
    typeList: string;
    popupVisible: boolean;
    artistAdded: string;
    rating: number;
    providerRating: number;
    trustedValue: boolean;
    gridClient: string;
    gridVenue: string;
    selectedServiceSubtypeId: string;
    serviceResetKeys: { [id: string]: number };
    providerServiceLookup: LookupTypeItem[];
    providerServiceHierarchy: any[];
    providerServiceId: string;
    providerSubTypeId: string;
    providerTypeId: string;
    providerTypeList: string;
}

class ArtistGridPage extends Component<ArtistGridPageProps> {
    //Initialize Service
    service: FindAnArtistService;
    //Initialize the State
    state: ArtistGridPageState;
    //Initialize the utilities
    utils: ArtistUtilities;
    lookupService: LookupService;

    constructor(props: ArtistGridPageProps) {
        super(props);
        this.service = new FindAnArtistService();
        this.utils = new ArtistUtilities();
        this.lookupService = new LookupService();
        this.state = {
            cardUIType: "",
            showProgressIndicator: false,
            formView: false,
            isPending:
                this.props.location && this.props.location.state && this.props.location.state.isPendingRequest
                    ? true
                    : false,
            requestStatus: this.props.location && this.props.location.state && this.props.location.state.reqStatus,
            typeListObject: this.utils.initializeFilterObject(),
            typeData: [],
            countOftypes: 0,
            artistSearchField: "",
            subTypesList: "",
            requestButtonClickCount: 0,
            firstTimeRequest: true,
            isPopUpToShow: false,
            artistSearchVal: "",
            isClickArtistSearch: false,
            isClickSearchButton: false,
            postCode: "",
            distance: "",
            typeList: "",
            popupVisible: false,
            artistAdded: "",
            rating: 0,
            providerRating: 0,
            trustedValue: false,
            gridClient: "",
            gridVenue: "",
            selectedServiceSubtypeId: "",
            serviceResetKeys: {},
            providerServiceLookup: [],
            providerServiceHierarchy: [],
            providerServiceId: "",
            providerSubTypeId: "",
            providerTypeId: "",
            providerTypeList: "",
        };
    }

    componentDidMount() {
        this.service.gettypeLookup().then(this.handleSuccessTypeLookUp).catch(this.handleStandardError);
        const serviceType = this.resolveArtistGridServiceType();
        GlobalService.setArtistGridComingFrom(serviceType);
        if (this.isArtistGridProviderView(serviceType)) {
            this.initializeProviderFilterLookups(serviceType);
        }
        if (this.state.isPending) {
            this.selectRequested();
        }
    }

    /**
     * Determines whether /artistGrid is being used for a provider listing flow.
     */
    isArtistGridProviderView = (serviceType: string): boolean => {
        return serviceType !== "Entertainment" && serviceType !== "Entertainment-profile";
    };

     
    /**
     * Normalizes service labels so source values and lookup values can be matched safely.
     */
    normalizeServiceLabel = (value: string): string => {
        return (value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    };

     
    /**
     * Maps /artistGrid source service keys to lookup display values used by provider filters.
     */
    mapArtistGridServiceToLookupLabel = (serviceType: string): string => {
        if (serviceType === "ContractCleaning") return "Contract Cleaning";
        if (serviceType === "Security") return "Door Supervision";
        if (serviceType === "Gardening") return "Gardening";
        if (serviceType === "Maintenance") return "Maintenance";
        if (serviceType === "Miscelleanous") return "Miscellaneous";
        if (serviceType === "WindowCleaning") return "Window Cleaning";
        return "";
    };

     
    /**
     * Maps /artistGrid source service keys to API service type ids used by provider endpoints.
     */
    mapArtistGridServiceToApiId = (serviceType: string): string => {
        if (serviceType === "ContractCleaning") return ServiceType.ContractCleaning;
        if (serviceType === "Security") return ServiceType.Security;
        if (serviceType === "Gardening") return ServiceType.Gardening;
        if (serviceType === "Maintenance") return ServiceType.Maintenance;
        if (serviceType === "Miscelleanous") return ServiceType.Miscelleanous;
        if (serviceType === "WindowCleaning") return ServiceType.WindowCleaning;
        return "";
    };

     
    /**
     * Provides resilient lookup-label candidates because service labels vary by endpoint.
     */
    getServiceLabelCandidates = (serviceType: string): string[] => {
        if (serviceType === "Security") return ["Door Supervision", "DoorSupervision", "Security"];
        if (serviceType === "Miscelleanous") return ["Miscelleanous", "Miscellaneous", "Misc"];
        if (serviceType === "ContractCleaning") return ["Contract Cleaning", "ContractCleaning"];
        if (serviceType === "WindowCleaning") return ["Window Cleaning", "WindowCleaning"];
        if (serviceType === "Gardening") return ["Gardening"];
        if (serviceType === "Maintenance") return ["Maintenance"];
        return [this.mapArtistGridServiceToLookupLabel(serviceType)];
    };

     
    /**
     * Loads provider service hierarchy and preselects the service inferred from /artistGrid source.
     */
    initializeProviderFilterLookups = (serviceType: string) => {
        const selectedServiceLabel = this.mapArtistGridServiceToLookupLabel(serviceType);
        const serviceTypeId = this.mapArtistGridServiceToApiId(serviceType);
        const labelCandidates = this.getServiceLabelCandidates(serviceType).map((item) => this.normalizeServiceLabel(item));
        this.lookupService
            .getServiceHierarchy()
            .then((response) => {
                const serviceOptions = response?.data?.data?.serviceOptions ? response.data.data.serviceOptions : [];
                const serviceLookup = serviceOptions.map((item: any) => ({
                    id: item.id,
                    value: item.value,
                    parentMappingId: "0",
                }));

                const selectedService = serviceOptions.find(
                    (item: any) =>
                        this.normalizeServiceLabel(item?.value?.toString()) ===
                        this.normalizeServiceLabel(selectedServiceLabel)
                );

                const selectedByCandidates = selectedService || serviceOptions.find((item: any) => {
                    const normalizedValue = this.normalizeServiceLabel(item?.value?.toString());
                    return labelCandidates.some(
                        (candidate) => normalizedValue.includes(candidate) || candidate.includes(normalizedValue)
                    );
                });

                const selectedById = selectedByCandidates || serviceOptions.find(
                    (item: any) => item?.id?.toString() === serviceTypeId
                );

                this.setState({
                    providerServiceLookup: serviceLookup,
                    providerServiceHierarchy: serviceOptions,
                    providerServiceId: selectedById?.id ? selectedById.id.toString() : "",
                    providerSubTypeId: "",
                    providerTypeId: "",
                    providerTypeList: "",
                });
            })
            .catch(() => {
                this.setState({
                    providerServiceLookup: [],
                    providerServiceHierarchy: [],
                    providerServiceId: "",
                    providerSubTypeId: "",
                    providerTypeId: "",
                    providerTypeList: "",
                });
            });
    };

     
    /**
     * Rebuilds the type list parameter expected by provider grid APIs.
     */
    buildProviderTypeListParam = (subTypeId: string, typeId: string): string => {
        if (subTypeId && typeId) {
            return `${subTypeId}-${typeId}`;
        }
        if (subTypeId) {
            return subTypeId;
        }
        return "";
    };

     
    /**
     * Returns the selected service display name for row-level provider service filtering.
     */
    getSelectedProviderServiceName = (): string => {
        if (!this.state.providerServiceId) return "";
        const selectedService = this.state.providerServiceHierarchy.find(
            (item: any) => item.id?.toString() === this.state.providerServiceId
        );
        return selectedService?.value ? selectedService.value.toString() : "";
    };

     
    /**
     * Filters subtype options by selected service where mapping is available.
     */
    getFilteredProviderSubTypes = (): any[] => {
        const { providerServiceHierarchy, providerServiceId } = this.state;
        if (!providerServiceId) {
            return [];
        }

        const selectedService = providerServiceHierarchy.find((item: any) => item.id?.toString() === providerServiceId);
        return selectedService?.subTypeOptions ? selectedService.subTypeOptions : [];
    };

     
    /**
     * Returns type options for the currently selected provider subtype.
     */
    getFilteredProviderTypes = (): any[] => {
        const { providerServiceId, providerSubTypeId } = this.state;
        if (!providerServiceId || !providerSubTypeId) {
            return [];
        }

        const selectedService = this.state.providerServiceHierarchy.find(
            (item: any) => item.id?.toString() === providerServiceId
        );
        const selectedSubType = selectedService?.subTypeOptions?.find(
            (item: any) => item.id?.toString() === providerSubTypeId
        );

        return selectedSubType?.typeOptions ? selectedSubType.typeOptions : [];
    };

     
    /**
     * Builds sub-type/type ids to match against provider rows for granular filtering.
     */
    getProviderFilterIds = (): string[] => {
        if (!this.state.providerSubTypeId) {
            return [];
        }

        if (this.state.providerTypeId) {
            return [this.state.providerTypeId];
        }

        const selectedSubType = this.getFilteredProviderSubTypes().find(
            (item: any) => item.id?.toString() === this.state.providerSubTypeId
        );
        const typeIds = selectedSubType?.typeOptions
            ? selectedSubType.typeOptions.map((item: any) => item.id?.toString()).filter(Boolean)
            : [];

        return [this.state.providerSubTypeId, ...typeIds];
    };

     
    /**
     * Handles provider service selection and clears dependent subtype/type filters.
     */
    handleProviderServiceChange = (event: SelectBoxOnValueChangedEvent) => {
        const serviceId = event.value ? event.value.toString() : "";
        this.setState({
            providerServiceId: serviceId,
            providerSubTypeId: "",
            providerTypeId: "",
            providerTypeList: "",
        });
    };

     
    /**
     * Handles provider subtype selection and resets child type.
     */
    handleProviderSubTypeChange = (event: SelectBoxOnValueChangedEvent) => {
        const subTypeId = event.value ? event.value.toString() : "";
        this.setState({
            providerSubTypeId: subTypeId,
            providerTypeId: "",
            providerTypeList: this.buildProviderTypeListParam(subTypeId, ""),
        });
    };

     
    /**
     * Handles provider type selection and updates composed typeList filter.
     */
    handleProviderTypeChange = (event: SelectBoxOnValueChangedEvent) => {
        const typeId = event.value ? event.value.toString() : "";
        this.setState((prevState: ArtistGridPageState) => ({
            providerTypeId: typeId,
            providerTypeList: this.buildProviderTypeListParam(prevState.providerSubTypeId, typeId),
        }));
    };

     
    /**
     * Resolves the current /artistGrid service type from route state first, then global fallback.
     */
    resolveArtistGridServiceType = (props: ArtistGridPageProps = this.props): string => {
        const stateServiceType = props.location?.state?.artistGridServiceType;
        if (stateServiceType) {
            return stateServiceType;
        }
        const globalServiceType = GlobalService.getArtistGridComingFrom();
        if (globalServiceType) {
            return globalServiceType;
        }
        return "WindowCleaning";
    };

    componentDidUpdate(prevProps: Readonly<ArtistGridPageProps>) {
        const serviceType = this.resolveArtistGridServiceType();
        const prevServiceType = this.resolveArtistGridServiceType(prevProps as ArtistGridPageProps);

        if (serviceType !== prevServiceType) {
            GlobalService.setArtistGridComingFrom(serviceType);
            this.setState(
                {
                    artistSearchField: "",
                    artistSearchVal: "",
                    isClickArtistSearch: false,
                    isClickSearchButton: false,
                    postCode: "",
                    distance: "",
                },
                () => {
                    if (this.isArtistGridProviderView(serviceType)) {
                        this.initializeProviderFilterLookups(serviceType);
                    } else {
                        this.setState({
                            providerServiceLookup: [],
                            providerServiceHierarchy: [],
                            providerServiceId: "",
                            providerSubTypeId: "",
                            providerTypeId: "",
                            providerTypeList: "",
                        });
                    }
                }
            );
        }

        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.navigateFrom) {
                if (this.props.location.state.navigateFrom != prevProps.location?.state?.navigateFrom) {
                    this.setState({
                        formView: false
                    });
                }
            }
        }
    }

    handleSuccessTypeLookUp = (response: AxiosResponse<any>) => {
        this.setState({
            typeData: response.data.data,
        });
    };

    handleStandardError = (error: any) => {
        var respMessage: string = "gettypeLookup failed with response: " + JSON.stringify(error);

        if (!this.service.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };

    selectRequested = () => {
        this.setState((prevState: ArtistGridPageState) => ({
            cardUIType: artistCardUIType.Requested,
            formView: true,

            requestButtonClickCount: prevState.requestButtonClickCount + 1,
            isPopUpToShow: false,
            firstTimeRequest:
                this.props.location.state &&
                    this.props.location.state.isNewRequest &&
                    prevState.requestButtonClickCount + 1 > 1
                    ? false
                    : true,
        }));
    };

    buildTypeListArray = (typeList: filterObject, selected: boolean, parentNodeClicked: boolean, deSelectType: boolean) => {
        let artistypeParam: string[] = [];
        let values: string = "";
        let subTypeTypeValues: string = "";
        this.setState({
            typeListObject: typeList,
            countOftypes: typeList.types.length,
        });
        if (typeList.serviceSubtype == ServiceSubTypeId.LiveMusic || typeList.serviceSubtype == ServiceSubTypeId.DJ || typeList.serviceSubtype == ServiceSubTypeId.PubQuiz) {
            if (typeList.types.length > 0) {
                artistypeParam = typeList.types.map((item: any) => {
                    return this.buildArtistTypeParameter(typeList.serviceSubtype, item);
                });
                values = artistypeParam.toString();
            } else {
                // Service selected without a specific child type — use subtype ID alone
                values = this.buildArtistTypeParameter(typeList.serviceSubtype);
            }
        }
        else {
            values = this.buildArtistTypeParameter(typeList.serviceSubtype);
        }
        if (deSelectType) {
            subTypeTypeValues = GlobalService.getArtistTypeSubType();
        }
        else if (selected && parentNodeClicked || selected && !parentNodeClicked) {
            if (parentNodeClicked) {
                // Parent (service) clicked — clear previously selected service and remount all
                const prev = this.state.selectedServiceSubtypeId;
                if (prev && prev !== typeList.serviceSubtype) {
                    GlobalService.removeArtistTypeSubType(prev, "");
                }
                const newKeys: { [id: string]: number } = {};
                this.state.typeData.forEach((item: any) => {
                    const id = item.id.toString();
                    newKeys[id] = (this.state.serviceResetKeys[id] || 0) + 1;
                });
                this.setState({ selectedServiceSubtypeId: typeList.serviceSubtype, serviceResetKeys: newKeys });
            } else {
                // Child type clicked — clear parent-service-level entry to avoid duplicate
                GlobalService.removeArtistTypeSubType(typeList.serviceSubtype, "");
            }
            GlobalService.setArtistTypeSubType(values);
            subTypeTypeValues = GlobalService.getArtistTypeSubType();
        }
        else if (!selected && parentNodeClicked) {
            GlobalService.removeArtistTypeSubType(typeList.serviceSubtype, "");
            subTypeTypeValues = GlobalService.getArtistTypeSubType();
            const newKeys: { [id: string]: number } = { ...this.state.serviceResetKeys };
            newKeys[typeList.serviceSubtype] = (newKeys[typeList.serviceSubtype] || 0) + 1;
            this.setState({ selectedServiceSubtypeId: "", serviceResetKeys: newKeys });
        }
        if (subTypeTypeValues.startsWith(",")) {
            subTypeTypeValues = subTypeTypeValues.slice(1);
        }
        this.setState({
            typeList: subTypeTypeValues
        });
    };

    buildArtistTypeParameter = (serviceSubTypeId: string, typeId?: string) => {
        if (serviceSubTypeId && typeId) {
            return `${serviceSubTypeId}-${typeId}`;
        }
        else if (serviceSubTypeId) {
            return `${serviceSubTypeId}`;
        }
        else {
            return "";
        }
    }

    searchArtists = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            artistSearchField: event.target.value
        });
    };

    onSearch = () => {
        this.setState({
            artistSearchVal: this.state.artistSearchField,
            isClickArtistSearch: true,
            isClickSearchButton: false,
            postCode: "",
            distance: ""
        });
    }

    setPostCodeDistance = (postalCode: string, radius: string) => {
        this.setState({
            postCode: postalCode,
            distance: radius,
            isClickArtistSearch: false,
            isClickSearchButton: true,
            artistSearchVal: this.state.artistSearchField
        });
    };

    getVenue = (client: string, venue:string) => {
        this.setState({
            gridClient: client,
            gridVenue: venue
        });
    }

    updateSearchButton = (flag: boolean) => {
        this.setState({
            isClickArtistSearch: flag,
            isClickSearchButton: flag
        });
    }

    handleChangeRating = (dxValueChange: SliderOnChangedEvent) => {
        this.setState({
            rating: dxValueChange.value,
        });
        if(dxValueChange && dxValueChange.element){
            dxValueChange.element.onkeydown=(event: any) => {
                if(event.key && event.key === 'Enter'){
                    this.onSearch();
                }
             }
            }
    };

    handleChangeProviderRating = (dxValueChange: SliderOnChangedEvent) => {
        this.setState({
            providerRating: dxValueChange.value,
        });
        if(dxValueChange && dxValueChange.element){
            dxValueChange.element.onkeydown=(event: any) => {
                if(event.key && event.key === 'Enter'){
                    this.onSearch();
                }
             }
            }
    };

    handleChangeTrusted = (dxValueChange: CheckBoxOnValueChanged) => {
        this.setState({
            trustedValue: dxValueChange.value
        });
        if(dxValueChange && dxValueChange.element){
        dxValueChange.element.onkeydown=(event: any) => {
            if(event.key && event.key === 'Enter'){
                this.onSearch();
            }
         }
        } 
    };
    
    addArtistPopup = () => {
        this.setState({
            popupVisible: true,
        });
    };

    hideArtistPopup = (e: any) => {
        e.cancel = true;
        this.setState({
            popupVisible: false,
        });
    };

    handleAddArtist = (isAdded: string) => {
        this.setState({ 
            artistAdded: isAdded,
            popupVisible: false,
         });
    }

     
    /**
     * Renders the provider filter sidebar used in /artistGrid View Providers flows.
     */
    renderProviderSidebar = (disableServiceSelection: boolean) => {
        return (
            <>
                <form
                    onSubmit={(e: any) => {
                        e.preventDefault();
                        this.onSearch();
                    }}
                >
                    <div className="filter-box__search mt-3">
                        <input
                            type="search"
                            onChange={this.searchArtists}
                            placeholder="Search for providers"
                        ></input>
                        <button type="submit">
                            <FontAwesomeIcon icon={faSearch} />
                            <span className="sr-only">Submit Search</span>
                        </button>
                    </div>
                </form>

                <div className="filter-box mt-3">
                    <h5 className="filter-box__section-header">Service</h5>
                    <div className="row mt-2">
                        <div className="col">
                            <SelectBox
                                dataSource={this.state.providerServiceLookup}
                                displayExpr="value"
                                valueExpr="id"
                                value={this.state.providerServiceId}
                                onValueChanged={this.handleProviderServiceChange}
                                disabled={disableServiceSelection}
                                placeholder="All Services"
                                showClearButton={!disableServiceSelection}
                                searchEnabled={true}
                            />
                        </div>
                    </div>

                    <h5 className="filter-box__section-header mt-3">Sub Type</h5>
                    <div className="row mt-2">
                        <div className="col">
                            <SelectBox
                                dataSource={this.getFilteredProviderSubTypes()}
                                displayExpr="value"
                                valueExpr="id"
                                value={this.state.providerSubTypeId}
                                onValueChanged={this.handleProviderSubTypeChange}
                                disabled={!this.state.providerServiceId}
                                placeholder="All Sub Types"
                                showClearButton={true}
                                searchEnabled={true}
                            />
                        </div>
                    </div>

                    <h5 className="filter-box__section-header mt-3">Type</h5>
                    <div className="row mt-2">
                        <div className="col">
                            <SelectBox
                                dataSource={this.getFilteredProviderTypes()}
                                displayExpr="value"
                                valueExpr="id"
                                value={this.state.providerTypeId}
                                onValueChanged={this.handleProviderTypeChange}
                                disabled={!this.state.providerSubTypeId}
                                placeholder="All Types"
                                showClearButton={true}
                                searchEnabled={true}
                            />
                        </div>
                    </div>

                    <h5 className="filter-box__section-header mt-3">Geography</h5>
                    <GeographyPanel
                        setPostCodeDistance={this.setPostCodeDistance}
                        location={this.props.location}
                        gridClient={""}
                        gridVenue={""}
                    />
                </div>
            </>
        );
    };

    render() {  
        let serviceType:any = this.resolveArtistGridServiceType();
        const isProviderView = this.isArtistGridProviderView(serviceType);
        const providerServiceName = isProviderView
            ? this.getSelectedProviderServiceName() || this.mapArtistGridServiceToLookupLabel(serviceType)
            : "";
        const providerServiceTypeId = isProviderView ? this.mapArtistGridServiceToApiId(serviceType) : "";
        let pageTitle;
        if(serviceType == "Entertainment"){
            pageTitle = "View Artists";
        }else if(serviceType == "Entertainment-profile"){
            pageTitle = "View Profiles"
        }
        else if(serviceType == "ContractCleaning") {
            pageTitle = "Contract Cleaning - View Providers";
        }
        else if(serviceType == "Security") {
            pageTitle = "Door Supervision - View Providers";
        }
        else if(serviceType == "Gardening") {
            pageTitle = "Gardening - View Providers";
        }
        else if(serviceType == "Maintenance") {
            pageTitle = "Maintenance - View Providers";
        }
        else if(serviceType == "Miscelleanous") {
            pageTitle = "Miscelleanous - View Providers";
        }
        else {
            pageTitle = "Window Cleaning - View Providers";
        }
        return (
            <LightModePageTemplate>               
                <SideBarTemplate isFullBleed={true}>
                    {isProviderView ? this.renderProviderSidebar(true) : <>
                    <form onSubmit={(e: any) => {
                        e.preventDefault();
                        this.onSearch();
                    }}>
                        <div className="filter-box__search mt-3">
                            <input
                                type="search"
                                onChange={this.searchArtists}
                                //aria-label="Search"
                                placeholder={serviceType == "Entertainment-profile"?"Search for profiles":"Search for artists"}
                            ></input>
                            <button type="submit"
                            // onClick={(e: MouseEvent) => {
                            //     e.preventDefault();
                            //     this.onSearch();
                            // }}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                                <span className="sr-only">Submit Search</span>
                            </button>
                        </div>
                    </form>
                    <div className="filter-box mt-3" hidden={!(serviceType == "Entertainment-profile" || serviceType == "Entertainment" )}>
                        <h5 className="filter-box__section-header">Artist type</h5>
                        <ul className="filter-box__filter-list">
                            {this.state.typeData.map((item: any, index: number) => {
                                return (
                                    (item.id == ServiceSubTypeId.LiveMusic || item.id == ServiceSubTypeId.DJ || item.id == ServiceSubTypeId.Karaoke || item.id == ServiceSubTypeId.PubQuiz || item.id == ServiceSubTypeId.Other) ?
                                        <FilterItem
                                            key={`${item.id.toString()}-${this.state.serviceResetKeys[item.id.toString()] || 0}`}
                                            item={item}
                                            sendTypeListToParent={this.buildTypeListArray}
                                            initialSelected={item.id.toString() === this.state.selectedServiceSubtypeId}
                                        /> : <></>
                                );
                            })}
                        </ul>
                        <div className="row mt-3">
                            <div className="col sidebar__heading">ARTIST RATING</div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <Slider
                                    min={0}
                                    max={5}
                                    value={this.state.rating}
                                    step={1}
                                    onValueChanged={this.handleChangeRating}
                                    tooltip={{
                                        enabled: true,
                                        showMode: "always",
                                        position: "bottom",
                                        format: () => {
                                            return `${this.state.rating} Stars`;
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <br></br><br></br><br></br>
                        <div className="row mt-3">
                            <div className="col sidebar__heading">PROVIDER RATING</div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <Slider
                                    min={0}
                                    max={5}
                                    value={this.state.providerRating}
                                    step={1}
                                    onValueChanged={this.handleChangeProviderRating}
                                    tooltip={{
                                        enabled: true,
                                        showMode: "always",
                                        position: "bottom",
                                        format: () => {
                                            return `${this.state.providerRating} Stars`;
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <br></br><br></br><br></br>
                        <div className="row mt-2">
                            <div className="col-2">
                                <div>
                                    <CheckBox value={this.state.trustedValue} onValueChanged={this.handleChangeTrusted} />
                                </div>
                            </div>
                            <div className="col-7 sidebar__heading">Only Show Trusted</div>
                        </div>
                        <br></br>
                        <h5 className="filter-box__section-header">Geography</h5>
                        <GeographyPanel setPostCodeDistance={this.setPostCodeDistance} location={this.props.location} gridClient={this.state.gridClient}
                            gridVenue={this.state.gridVenue}></GeographyPanel>
                    </div></>}
                </SideBarTemplate>
                <div className="page-content--with-sidebar">
                    <div className="find-an-artist-header">
                        <div>
                            <h2 className="page-title__black">
                                {pageTitle}
                            </h2>
                        </div>
                    </div>
                    <div className="row" hidden={serviceType == "Entertainment-profile" ||serviceType == "Entertainment"}>
                        <div className="col-2 mt-3 mb-3">
                            <Button
                                className="btn btn-primary btn--large"
                                disabled={false}
                                onClick={this.addArtistPopup}
                            >
                                ADD PROFILE
                            </Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md">
                            <ArtistGrid
                                location={this.props.location}
                                history={this.props.history}
                                typeListObject={this.state.typeListObject}
                                countOftypes={this.state.countOftypes}
                                requestStatus={this.state.requestStatus}
                                postCode={this.state.postCode}
                                distance={this.state.distance}
                                trustedValue={this.state.trustedValue}
                                rating={this.state.rating}
                                getVenue={this.getVenue}
                                isShowPopUp={this.state.isPopUpToShow}
                                searchFieldVal={this.state.artistSearchVal}
                                typeList={isProviderView ? this.state.providerTypeList : this.state.typeList}
                                isClickArtistSearch={this.state.isClickArtistSearch}
                                isClickSearchButton={this.state.isClickSearchButton}
                                updateSearchButton={this.updateSearchButton}
                                serviceType={isProviderView ? "viewProviders" : serviceType}
                                providerServiceTypeId={providerServiceTypeId}
                                serviceTypeFilter={this.state.providerServiceId}
                                providerFilterIds={this.getProviderFilterIds()}
                                providerServiceName={providerServiceName}
                                artistAdded={this.state.artistAdded}
                                providerRating={this.state.providerRating}
                            />
                        </div>
                    </div>                    
                    {
                        this.state.popupVisible ? (
                            <Popup
                                visible={this.state.popupVisible}
                                onHiding={this.hideArtistPopup}
                                dragEnabled={false}
                                hideOnOutsideClick={false}
                                showTitle={true}
                                showCloseButton={true}
                                title={serviceType == "Entertainment" ? "Add Artist" : "Add Provider"}
                                resizeEnabled={true}
                            >
                                <ScrollView width="100%" height="100%">
                                    <ArtistProfileComponent
                                        mode="edit"
                                        id="0"
                                        businessEntityId="0"
                                        handlePopUpClose={() => { return null }}
                                        handleFeedbackUpdate={() => { return null }}
                                        handleAddArtist={this.handleAddArtist}
                                        serviceType={serviceType}
                                    ></ArtistProfileComponent>
                                </ScrollView>
                            </Popup>
                        ) : null
                    }
                </div>

            </LightModePageTemplate>
        );
    }
}
export default withRouter(ArtistGridPage);
